import { Moon, Sun } from 'lucide-react';
import { useIntl } from '@/core/i18n/use-intl';
import { useTheme } from '@/core/theme/use-theme';

export function ThemeToggle() {
  const { t } = useIntl();
  const { isDarkMode, setThemeMode } = useTheme();

  const toggleTheme = () => {
    setThemeMode(isDarkMode ? 'light' : 'dark');
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="w-full flex items-center gap-3 px-2 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
    >
      {isDarkMode ? <Sun className="size-[18px]" /> : <Moon className="size-[18px]" />}
      <span className="flex-1 text-left">
        {isDarkMode ? t('settings.light') : t('settings.dark')}
      </span>
    </button>
  );
}
